// ComerciaisManager.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Hoot from "../../Hoot";
import { toast } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button, Tabs, Tab, Form, Spinner } from "react-bootstrap";

import { Avatar } from "@mui/material";

import {
  FiUsers,
  FiRefreshCw,
  FiPlus,
  FiEdit3,
  FiTrash2,
  FiPaperclip,
  FiCheckSquare,
  FiSearch,
  FiUpload,
} from "react-icons/fi";
import { TbBuilding, TbMapPin, TbPhone, TbMail, TbSchool } from "react-icons/tb";

const PHOTO_FIELD = "photo"; // <-- ajusta se necessário

// ========================
// CSS (mesmo “family” do Contacts)
// ========================
const styles = `
:root{
  --primary:#5b5cff;
  --primary2:#7c3aed;
  --bg:#f4f6fb;
  --card:#ffffff;
  --border:#e6eaf2;
  --text:#0f172a;
  --muted:#64748b;
  --shadow: 0 14px 40px rgba(15,23,42,.08);
}

.cm-shell{
  background:var(--bg);
  padding:10px;
}
.cm-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:12px 14px 14px;
  box-shadow: var(--shadow);
}

/* header */
.cm-header{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:flex-start;
  gap:10px;
  margin-bottom:10px;
}
.cm-header-title{
  font-weight:700;
  font-size:1.02rem;
  display:flex;
  align-items:center;
  gap:.55rem;
  color:var(--text);
}
.cm-chip{
  display:inline-flex;
  align-items:center;
  gap:.35rem;
  padding:.28rem .62rem;
  border-radius:999px;
  background:linear-gradient(135deg, rgba(91,92,255,.14), rgba(124,58,237,.12));
  color:#4338ca;
  font-size:.78rem;
  font-weight:600;
  border:1px solid rgba(91,92,255,.16);
}

/* toolbar */
.cm-toolbar{
  margin-top:6px;
  padding:10px 10px;
  border-radius:14px;
  background:linear-gradient(180deg, rgba(148,163,184,0.12), rgba(148,163,184,0.06));
  border:1px solid rgba(226,232,240,.7);
  margin-bottom:10px;
}
.small-muted{ font-size:.78rem; color:var(--muted); }

/* table */
.cm-table-wrapper{ width:100%; }
@media (max-width:768px){
  .cm-table-desktop{display:none;}
  .cm-mobile-list{display:block;}
}
@media (min-width:769px){
  .cm-table-desktop{display:block;}
  .cm-mobile-list{display:none;}
}
.cm-table{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:.86rem;
  color:var(--text);
}
.cm-table thead th{
  text-align:left;
  padding:.62rem .65rem;
  font-size:.78rem;
  font-weight:650;
  color:var(--muted);
  border-bottom:1px solid var(--border);
  background:var(--card);
  position:sticky;
  top:0;
  z-index:1;
}
.cm-table tbody td{
  padding:.62rem .65rem;
  border-bottom:1px solid var(--border);
  vertical-align:middle;
}
.cm-table tbody tr:hover{
  background:rgba(148,163,184,0.10);
}

.pill{
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:4px 10px;
  border-radius:999px;
  font-size:.74rem;
  font-weight:600;
  border:1px solid rgba(15,23,42,.08);
  background:rgba(226,232,240,.55);
  color:#0f172a;
}
.pill svg{ opacity:.9; }

.status-badge{
  display:inline-flex;
  align-items:center;
  gap:8px;
  padding:6px 10px;
  border-radius:999px;
  font-size:.74rem;
  font-weight:650;
  border:1px solid rgba(0,0,0,.06);
  letter-spacing:.2px;
}
.status-dot{
  width:8px;height:8px;border-radius:999px;
  background:currentColor;
  box-shadow: 0 0 0 4px rgba(0,0,0,.04);
}
.s-ativo{ background: rgba(34,197,94,.14); color:#22c55e; }
.s-inativo{ background: rgba(245,158,11,.18); color:#f59e0b; }
.s-outro{ background: rgba(148,163,184,.18); color:#64748b; }

.btn-icon{
  width:34px;
  height:34px;
  border-radius:12px;
  border:1px solid rgba(226,232,240,.95);
  background:#fff;
  display:inline-grid;
  place-items:center;
  cursor:pointer;
  transition: transform .08s ease, background .12s ease;
}
.btn-icon:hover{ background: rgba(91,92,255,.06); }
.btn-icon:active{ transform: scale(.98); }
.btn-icon svg{ font-size:1.05rem; color:#334155; }

.actions-row{ display:flex; justify-content:flex-end; gap:8px; flex-wrap:wrap; }

/* mobile cards */
.cm-mobile-list{ margin-top:4px; }
.mcard{
  background:var(--card);
  border-radius:16px;
  border:1px solid var(--border);
  padding:12px 12px;
  margin:8px 0;
  box-shadow: 0 10px 26px rgba(2,6,23,.06);
}
.mrow{ display:flex; align-items:center; justify-content:space-between; gap:12px; }
.mline{ height:1px; background:var(--border); margin:10px 0; }
.mtitle{ font-weight:650; color:var(--text); font-size:.92rem; }
.msub{ color:var(--muted); font-size:.78rem; margin-top:2px; }

/* grid tab */
.grid{
  display:grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap:12px;
  margin-top:10px;
}
@media (max-width:1200px){
  .grid{ grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width:900px){
  .grid{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width:520px){
  .grid{ grid-template-columns: 1fr; }
}
.gcard{
  background:var(--card);
  border:1px solid var(--border);
  border-radius:18px;
  box-shadow: 0 10px 26px rgba(2,6,23,.06);
  overflow:hidden;
}
.ghead{
  padding:12px 12px 10px;
  background:
    radial-gradient(900px 220px at 18% 0%, rgba(91,92,255,.14), transparent 60%),
    radial-gradient(780px 200px at 92% 0%, rgba(124,58,237,.10), transparent 55%),
    #ffffff;
  border-bottom:1px solid rgba(226,232,240,.9);
}
.gbody{ padding:10px 12px 12px; }
.gtitle{ font-weight:750; color:var(--text); font-size:.95rem; }
.gsub{ color:var(--muted); font-size:.78rem; margin-top:2px; display:flex; gap:8px; flex-wrap:wrap; }
.gactions{ padding:10px 12px 12px; display:flex; gap:8px; justify-content:flex-end; border-top:1px solid rgba(226,232,240,.9); background:#fff; }

/* pagination footer */
.cm-footer{
  margin-top:10px;
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  flex-wrap:wrap;
}

/* ===== Pretty modal (igual ao registo de contactos) ===== */
.pretty-modal .modal-dialog{ max-width: 820px; }
@media (max-width: 768px){ .pretty-modal .modal-dialog{ max-width: 96vw; } }
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}
.body-scroll{ 
  overflow-y: auto;
  padding-right: 4px;
}
.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}
.header-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
}
.header-left{
  display:flex;
  align-items:center;
  gap:12px;
}
.icon-wrap{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(91,92,255,.10);
  border: 1px solid rgba(91,92,255,.18);
  display:grid;
  place-items:center;
}
.title-sub{
  margin-top:2px;
  font-size: .8rem;
  color: #64748b;
  font-weight: 500;
}

.form-grid{
  display:grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}
@media (max-width: 720px){ .form-grid{ grid-template-columns: 1fr; } }

.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem;
  color:#64748b;
  font-weight: 600;
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom: 8px;
}
.req{ color:#ef4444; font-weight:700; }

.form-control, .form-select{
  border-radius: 4px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}

.helper{
  font-size: .74rem;
  color:#64748b;
  margin-top: 6px;
}
.upload-row{
  display:flex;
  align-items:flex-start;
  gap:12px;
  flex-wrap:wrap;
}
.preview-box{
  width: 96px;
  height: 96px;
  border-radius: 18px;
  border: 1px dashed rgba(148,163,184,.55);
  background: rgba(248,250,252,.75);
  display:grid;
  place-items:center;
  overflow:hidden;
}
.preview-note{
  font-size:.72rem;
  color:#94a3b8;
  padding: 0 10px;
  text-align:center;
}
.actions{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  flex-wrap:wrap;
}
.btn-soft{
  border-radius: 999px !important;
  border: 1px solid rgba(226,232,240,.95) !important;
  background: #fff !important;
}
.btn-primary{
  border-radius: 999px !important;
}

/* Assign schools table (striped + clean) */
.assign-wrap{
  border:1px solid rgba(226,232,240,.95);
  border-radius:16px;
  overflow:hidden;
  background:#fff;
}
.assign-head{
  padding:10px 12px;
  border-bottom:1px solid rgba(226,232,240,.95);
  background: rgba(248,250,252,.75);
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  flex-wrap:wrap;
}
.assign-table{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:.84rem;
}
.assign-table th{
  text-align:left;
  padding:.56rem .6rem;
  font-size:.78rem;
  font-weight:650;
  color:var(--muted);
  border-bottom:1px solid rgba(226,232,240,.95);
  background:#fff;
}
.assign-table td{
  padding:.56rem .6rem;
  border-bottom:1px solid rgba(226,232,240,.75);
  vertical-align:middle;
}
.assign-table tbody tr:nth-child(odd){
  background: rgba(148,163,184,.06);
}
.assign-table tbody tr:hover{
  background: rgba(91,92,255,.06);
}
.chk{
  width:18px;height:18px;
  accent-color: var(--primary);
}
`;

// ========================
// Helpers
// ========================
function normalizeStr(str) {
  return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";
}
function safeValue(v, fallback = "—") {
  return v === null || v === undefined || v === "" ? fallback : v;
}
function statusClass(status) {
  const s = normalizeStr(status);
  if (s === "ativo") return "s-ativo";
  if (s === "inativo") return "s-inativo";
  return "s-outro";
}

function buildPageButtons(currentOneBased, pageCount) {
  const current = currentOneBased;
  const maxButtons = 7;
  const pages = [];

  if (pageCount <= maxButtons) {
    for (let i = 1; i <= pageCount; i++) pages.push(i);
    return pages;
  }

  pages.push(1);
  let start = Math.max(2, current - 1);
  let end = Math.min(pageCount - 1, current + 1);

  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < pageCount - 1) pages.push("...");
  pages.push(pageCount);

  return pages;
}

function resolvePhotoSrc(photoOrPath) {
  if (!photoOrPath) return null;
  const s = String(photoOrPath);
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  if (s.startsWith("/")) return `${Hoot().slice(0, -1)}${s}`;
  return s;
}

function getCommercialPhoto(row) {
  return (
    row?.photo ||
    row?.picture ||
    row?.avatar ||
    row?.image ||
    row?.ed_comercial_picture ||
    row?.ed_comercial_photo ||
    row?.profile_photo ||
    null
  );
}

function calcRangeText(page, limit, total) {
  if (!total) return "0";
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);
  return `${start}-${end}`;
}

// ========================
// Component
// ========================
export default function ComerciaisManager() {
  const [activeTab, setActiveTab] = useState("listagem");

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  //  agora é server-side
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1); // 1-based
  const [limit, setLimit] = useState(50);

  const [institutes, setInstitutes] = useState([]);

  const [q, setQ] = useState("");
  const [status, setStatus] = useState(""); // opcional (ativo/inativo)

  // modal form
  const [openForm, setOpenForm] = useState(false);
  const [editing, setEditing] = useState(null);

  // foto (form)
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    region: "",
    status: "ativo",
    notes: "",
  });

  // modal assign
  const [openAssign, setOpenAssign] = useState(false);
  const [assignCommercial, setAssignCommercial] = useState(null);
  const [selectedInstituteCodes, setSelectedInstituteCodes] = useState([]);
  const [assignQ, setAssignQ] = useState("");

  // modal docs (upload simples)
  const [openDocs, setOpenDocs] = useState(false);
  const [docsCommercial, setDocsCommercial] = useState(null);
  const [docTitle, setDocTitle] = useState("");
  const [docNote, setDocNote] = useState("");
  const [docFiles, setDocFiles] = useState([]);

  const pageCount = useMemo(() => Math.max(1, Math.ceil((total || 0) / (limit || 1))), [total, limit]);
  const pageButtons = useMemo(() => buildPageButtons(page, pageCount), [page, pageCount]);
  const rangeText = useMemo(() => calcRangeText(page, limit, total), [page, limit, total]);

  //  load com endpoint novo (objeto {data,total...})
  const load = async (opts = {}) => {
    try {
      setLoading(true);
      setError(null);

      const nextPage = opts.page ?? page;
      const nextLimit = opts.limit ?? limit;
      const nextQ = opts.q ?? q;
      const nextStatus = opts.status ?? status;

      const [comRes, instRes] = await Promise.all([
        axios.get(Hoot() + "comerciais", {
          withCredentials: true,
          params: {
            search: nextQ || undefined,
            status: nextStatus || undefined,
            page: nextPage,
            limit: nextLimit,
          },
        }),
        axios.get(Hoot() + "institutes", { withCredentials: true }),
      ]);

      //  suporta resposta nova e antiga
      const payload = comRes.data;
      const dataArr = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload) ? payload : [];
      const totalCount = typeof payload?.total === "number" ? payload.total : dataArr.length;

      setRows(dataArr);
      setTotal(totalCount);

      setInstitutes(Array.isArray(instRes.data?.data) ? instRes.data.data : (instRes.data || []));
    } catch (e) {
      setError("Erro ao carregar comerciais.");
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load({ page, limit, q, status });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, status]);

  // quando muda o texto de pesquisa, volta para página 1 e recarrega
  useEffect(() => {
    const t = setTimeout(() => {
      setPage(1);
      load({ page: 1, limit, q, status });
    }, 350);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  const resetFormState = () => {
    setPhotoFile(null);
    setPhotoPreview(null);
    setForm({ name: "", email: "", phone: "", region: "", status: "ativo", notes: "" });
  };

  const startCreate = () => {
    setEditing(null);
    resetFormState();
    setOpenForm(true);
  };

  const startEdit = (row) => {
    setEditing(row);
    setForm({
      name: row?.name || "",
      email: row?.email || "",
      phone: row?.phone || "",
      region: row?.region || "",
      status: row?.status || "ativo",
      notes: row?.notes || "",
    });

    const src = resolvePhotoSrc(getCommercialPhoto(row));
    setPhotoPreview(src || null);
    setPhotoFile(null);

    setOpenForm(true);
  };

  const closeForm = () => {
    if (saving) return;
    setOpenForm(false);
    setEditing(null);
    setError(null);
    resetFormState();
  };

  const handlePhotoChange = (e) => {
    const f = e.target.files?.[0] || null;
    setPhotoFile(f);

    if (!f) {
      if (!editing) setPhotoPreview(null);
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => setPhotoPreview(reader.result);
    reader.readAsDataURL(f);
  };

  const saveCommercial = async () => {
    if (!form.name.trim()) {
      setError("Nome é obrigatório.");
      return;
    }

    try {
      setSaving(true);
      setError(null);

      const hasPhoto = !!photoFile;

      if (hasPhoto) {
        const fd = new FormData();
        Object.entries(form).forEach(([k, v]) => fd.append(k, v ?? ""));
        fd.append(PHOTO_FIELD, photoFile);

        if (editing?.id) {
          await axios.put(Hoot() + `comerciais/${editing.id}`, fd, {
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" },
          });
        } else {
          await axios.post(Hoot() + "comerciais/create", fd, {
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
      } else {
        if (editing?.id) {
          await axios.put(Hoot() + `comerciais/${editing.id}`, form, { withCredentials: true });
        } else {
          await axios.post(Hoot() + "comerciais/create", form, { withCredentials: true });
        }
      }

      toast.success(editing?.id ? "Comercial atualizado." : "Comercial criado.");
      closeForm();
      await load({ page, limit, q, status });
    } catch {
      setError("Erro ao guardar comercial.");
    } finally {
      setSaving(false);
    }
  };

  const deleteCommercial = async (row) => {
    if (!window.confirm(`Remover comercial "${row?.name}"?`)) return;
    try {
      setSaving(true);
      setError(null);
      await axios.delete(Hoot() + `comerciais/${row.id}`, { withCredentials: true });
      toast.success("Comercial removido.");
      await load({ page, limit, q, status });
    } catch {
      setError("Erro ao remover comercial.");
    } finally {
      setSaving(false);
    }
  };

  // ===== Assign schools =====
  const startAssign = async (row) => {
    try {
      setSaving(true);
      setError(null);
      setAssignCommercial(row);
      setAssignQ("");

      const res = await axios.get(Hoot() + `comerciais/${row.id}/assignments`, { withCredentials: true });
      setSelectedInstituteCodes((res.data || []).map((x) => x.institute_code));
      setOpenAssign(true);
    } catch {
      setError("Erro ao carregar atribuições.");
    } finally {
      setSaving(false);
    }
  };

  const closeAssign = () => {
    if (saving) return;
    setOpenAssign(false);
    setAssignCommercial(null);
    setSelectedInstituteCodes([]);
    setAssignQ("");
  };

  const toggleInstitute = (code) => {
    setSelectedInstituteCodes((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]
    );
  };

  const assignFilteredInstitutes = useMemo(() => {
    const s = normalizeStr(assignQ);
    if (!s) return institutes || [];
    return (institutes || []).filter((inst) => {
      const hay = [inst.name, inst.code, inst.state, inst.nif].map(normalizeStr).join(" ");
      return hay.includes(s);
    });
  }, [institutes, assignQ]);

  const selectAllVisible = () => {
    const visibleCodes = assignFilteredInstitutes.map((i) => i.code).filter(Boolean);
    setSelectedInstituteCodes((prev) => Array.from(new Set([...prev, ...visibleCodes])));
  };

  const clearAll = () => setSelectedInstituteCodes([]);

  const saveAssignments = async () => {
    if (!assignCommercial?.id) return;
    try {
      setSaving(true);
      setError(null);

      await axios.put(
        Hoot() + `comerciais/${assignCommercial.id}/assignments`,
        { institute_codes: selectedInstituteCodes },
        { withCredentials: true }
      );

      toast.success("Atribuições guardadas.");
      closeAssign();
      await load({ page, limit, q, status });
    } catch {
      setError("Erro ao guardar atribuições.");
    } finally {
      setSaving(false);
    }
  };

  // ===== Docs (upload simples) =====
  const startDocs = (row) => {
    setDocsCommercial(row);
    setDocTitle("");
    setDocNote("");
    setDocFiles([]);
    setOpenDocs(true);
  };

  const closeDocs = () => {
    if (saving) return;
    setOpenDocs(false);
    setDocsCommercial(null);
    setDocTitle("");
    setDocNote("");
    setDocFiles([]);
  };

  const uploadDocs = async () => {
    if (!docsCommercial?.id) return;
    if (!docTitle.trim()) {
      setError("Título do documento é obrigatório.");
      return;
    }
    if (!docFiles.length) {
      setError("Selecione pelo menos 1 ficheiro.");
      return;
    }

    try {
      setSaving(true);
      setError(null);

      const fd = new FormData();
      fd.append("title", docTitle);
      fd.append("note", docNote);
      for (const f of docFiles) fd.append("files", f);

      await axios.post(Hoot() + `comerciais/${docsCommercial.id}/docs/upload`, fd, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Documentos enviados.");
      closeDocs();
    } catch {
      setError("Erro ao enviar documentos.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <style>{styles}</style>

      <div className="cm-shell">
        <div className="cm-card">
          {/* HEADER */}
          <div className="cm-header">
            <div className="cm-header-title">
              <FiUsers style={{ color: "var(--primary)", fontSize: 20 }} />
              <span>Comerciais</span>
              <span className="cm-chip">
                {total || 0} comerciais
              </span>
            </div>

            <div className="d-flex flex-wrap gap-2">
              <button
                className="btn btn-outline-dark btn-sm rounded-pill d-flex align-items-center"
                onClick={() => load({ page, limit, q, status })}
                disabled={loading}
              >
                <FiRefreshCw className="me-2" />
                Recarregar
              </button>

              <button
                className="btn btn-outline-primary btn-sm rounded-pill d-flex align-items-center"
                onClick={startCreate}
                disabled={saving}
              >
                <FiPlus className="me-2" />
                Adicionar
              </button>
            </div>
          </div>

          {error ? (
            <div className="alert alert-danger py-2 mb-2" style={{ borderRadius: 14 }}>
              {error}
            </div>
          ) : null}

          {/* TOOLBAR */}
          <div className="cm-toolbar">
            <div className="row g-2 align-items-center">
              <div className="col-12 col-md-7">
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-white">
                    <FiSearch />
                  </span>
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Pesquisar (nome, email, telefone, região...)"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-12 col-md-3">
                <Form.Select size="sm" value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }}>
                  <option value="">Todos estados</option>
                  <option value="ativo">Ativo</option>
                  <option value="inativo">Inativo</option>
                </Form.Select>
              </div>

              <div className="col-12 col-md-2">
                <Form.Select size="sm" value={limit} onChange={(e) => { setLimit(Number(e.target.value || 50)); setPage(1); }}>
                  <option value={20}>20 / pág</option>
                  <option value={50}>50 / pág</option>
                  <option value={100}>100 / pág</option>
                  <option value={200}>200 / pág</option>
                </Form.Select>
              </div>
            </div>
          </div>

          {/* TABS */}
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k || "listagem")}
            className="mb-2"
          >
            {/* TAB 1: LISTAGEM */}
            <Tab eventKey="listagem" title="Listagem">
              <div className="cm-table-wrapper">
                <div className="cm-table-desktop">
                  <div style={{ overflowX: "auto" }}>
                    <table className="cm-table">
                      <thead>
                        <tr>
                          <th>Foto</th>
                          <th>Nome</th>
                          <th>Email</th>
                          <th>Telefone</th>
                          <th>Região</th>
                          <th>Estado</th>
                          <th>Escolas atribuídas</th>
                          <th className="text-end">Ações</th>
                        </tr>
                      </thead>

                      <tbody>
                        {(rows || []).map((r) => {
                          const src = resolvePhotoSrc(getCommercialPhoto(r));
                          return (
                            <tr key={r.id}>
                              <td>
                                <Avatar
                                  variant="rounded"
                                  src={src || undefined}
                                  alt={r.name}
                                  sx={{ width: 44, height: 44, borderRadius: 3 }}
                                />
                              </td>

                              <td style={{ fontWeight: 650 }}>{safeValue(r.name, "Sem nome")}</td>

                              <td>
                                {r.email ? (
                                  <a href={`mailto:${r.email}`} style={{ textDecoration: "none" }}>
                                    <span className="d-inline-flex align-items-center gap-2">
                                      <TbMail style={{ color: "#64748b" }} />
                                      {r.email}
                                    </span>
                                  </a>
                                ) : (
                                  <span className="small-muted">—</span>
                                )}
                              </td>

                              <td>
                                <span className="d-inline-flex align-items-center gap-2">
                                  <TbPhone style={{ color: "#64748b" }} />
                                  {safeValue(r.phone)}
                                </span>
                              </td>

                              <td>
                                <span className="pill">
                                  <TbMapPin />
                                  {safeValue(r.region)}
                                </span>
                              </td>

                              <td>
                                <span className={`status-badge ${statusClass(r.status)}`}>
                                  <span className="status-dot" />
                                  {safeValue(r.status, "—")}
                                </span>
                              </td>

                              <td>
                                <span className="pill">
                                  <TbSchool />
                                  {r.assigned_count ?? 0}
                                </span>
                              </td>

                              <td className="text-end">
                                <div className="actions-row">
                                  <button
                                    className="btn-icon"
                                    type="button"
                                    title="Atribuir escolas"
                                    onClick={() => startAssign(r)}
                                    disabled={saving}
                                  >
                                    <FiCheckSquare />
                                  </button>

                                  <button
                                    className="btn-icon"
                                    type="button"
                                    title="Anexos"
                                    onClick={() => startDocs(r)}
                                    disabled={saving}
                                  >
                                    <FiPaperclip />
                                  </button>

                                  <button
                                    className="btn-icon"
                                    type="button"
                                    title="Editar"
                                    onClick={() => startEdit(r)}
                                    disabled={saving}
                                  >
                                    <FiEdit3 />
                                  </button>

                                  <button
                                    className="btn-icon"
                                    type="button"
                                    title="Remover"
                                    onClick={() => deleteCommercial(r)}
                                    disabled={saving}
                                  >
                                    <FiTrash2 style={{ color: "#ef4444" }} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}

                        {(rows || []).length === 0 ? (
                          <tr>
                            <td colSpan={8}>
                              <span className="small-muted">{loading ? "A carregar..." : "Sem dados."}</span>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Mobile cards */}
                <div className="cm-mobile-list">
                  {(rows || []).map((r) => {
                    const src = resolvePhotoSrc(getCommercialPhoto(r));
                    return (
                      <div className="mcard" key={r.id}>
                        <div className="mrow">
                          <div className="d-flex align-items-center gap-2">
                            <Avatar
                              variant="rounded"
                              src={src || undefined}
                              alt={r.name}
                              sx={{ width: 44, height: 44, borderRadius: 3 }}
                            />
                            <div>
                              <div className="mtitle">{safeValue(r.name, "Sem nome")}</div>
                              <div className="msub d-flex flex-wrap gap-2">
                                <span className="pill">
                                  <TbMapPin />
                                  {safeValue(r.region)}
                                </span>
                                <span className="pill">
                                  <TbSchool />
                                  {r.assigned_count ?? 0}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className={`status-badge ${statusClass(r.status)}`}>
                            <span className="status-dot" />
                            {safeValue(r.status, "—")}
                          </div>
                        </div>

                        <div className="mline" />

                        <div className="d-flex flex-wrap gap-2">
                          <span className="pill">
                            <TbPhone />
                            {safeValue(r.phone)}
                          </span>
                          <span className="pill">
                            <TbMail />
                            {safeValue(r.email)}
                          </span>
                        </div>

                        <div className="mline" />

                        <div className="d-flex justify-content-end gap-2">
                          <button className="btn-icon" onClick={() => startAssign(r)} title="Atribuir escolas">
                            <FiCheckSquare />
                          </button>
                          <button className="btn-icon" onClick={() => startDocs(r)} title="Anexos">
                            <FiPaperclip />
                          </button>
                          <button className="btn-icon" onClick={() => startEdit(r)} title="Editar">
                            <FiEdit3 />
                          </button>
                          <button className="btn-icon" onClick={() => deleteCommercial(r)} title="Remover">
                            <FiTrash2 style={{ color: "#ef4444" }} />
                          </button>
                        </div>
                      </div>
                    );
                  })}

                  {(rows || []).length === 0 ? <span className="small-muted">{loading ? "A carregar..." : "Sem dados."}</span> : null}
                </div>
              </div>

              {/* FOOTER + PAGINATION */}
              <div className="cm-footer">
                <div className="small-muted">
                  Mostrando <b>{rangeText}</b> de <b>{total}</b>
                </div>

                {pageCount > 1 ? (
                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage((p) => Math.max(1, p - 1))}>
                          «
                        </button>
                      </li>

                      {pageButtons.map((p, idx) =>
                        p === "..." ? (
                          <li key={`e-${idx}`} className="page-item disabled">
                            <span className="page-link">…</span>
                          </li>
                        ) : (
                          <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                            <button className="page-link" onClick={() => setPage(p)}>
                              {p}
                            </button>
                          </li>
                        )
                      )}

                      <li className={`page-item ${page === pageCount ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage((p) => Math.min(pageCount, p + 1))}>
                          »
                        </button>
                      </li>
                    </ul>
                  </nav>
                ) : null}
              </div>
            </Tab>

            {/* TAB 2: GRID */}
            <Tab eventKey="grid" title="Grid">
              <div className="grid">
                {(rows || []).map((r) => {
                  const src = resolvePhotoSrc(getCommercialPhoto(r));
                  return (
                    <div className="gcard" key={r.id}>
                      <div className="ghead">
                        <div className="d-flex align-items-center gap-2">
                          <Avatar
                            variant="rounded"
                            src={src || undefined}
                            alt={r.name}
                            sx={{ width: 52, height: 52, borderRadius: 4 }}
                          />
                          <div style={{ flex: 1 }}>
                            <div className="gtitle">{safeValue(r.name, "Sem nome")}</div>
                            <div className="gsub">
                              <span className={`status-badge ${statusClass(r.status)}`}>
                                <span className="status-dot" />
                                {safeValue(r.status, "—")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="gbody">
                        <div className="gsub">
                          <span className="pill">
                            <TbMail />
                            {safeValue(r.email)}
                          </span>
                          <span className="pill">
                            <TbPhone />
                            {safeValue(r.phone)}
                          </span>
                          <span className="pill">
                            <TbMapPin />
                            {safeValue(r.region)}
                          </span>
                          <span className="pill">
                            <TbBuilding />
                            Escolas: {r.assigned_count ?? 0}
                          </span>
                        </div>
                      </div>

                      <div className="gactions">
                        <button className="btn-icon" title="Atribuir escolas" onClick={() => startAssign(r)} disabled={saving}>
                          <FiCheckSquare />
                        </button>
                        <button className="btn-icon" title="Anexos" onClick={() => startDocs(r)} disabled={saving}>
                          <FiPaperclip />
                        </button>
                        <button className="btn-icon" title="Editar" onClick={() => startEdit(r)} disabled={saving}>
                          <FiEdit3 />
                        </button>
                        <button className="btn-icon" title="Remover" onClick={() => deleteCommercial(r)} disabled={saving}>
                          <FiTrash2 style={{ color: "#ef4444" }} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

              {(rows || []).length === 0 ? <div className="small-muted mt-2">{loading ? "A carregar..." : "Sem dados."}</div> : null}

              <div className="cm-footer">
                <div className="small-muted">
                  Mostrando <b>{rangeText}</b> de <b>{total}</b>
                </div>

                {pageCount > 1 ? (
                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage((p) => Math.max(1, p - 1))}>
                          «
                        </button>
                      </li>

                      {pageButtons.map((p, idx) =>
                        p === "..." ? (
                          <li key={`e2-${idx}`} className="page-item disabled">
                            <span className="page-link">…</span>
                          </li>
                        ) : (
                          <li key={`g-${p}`} className={`page-item ${page === p ? "active" : ""}`}>
                            <button className="page-link" onClick={() => setPage(p)}>
                              {p}
                            </button>
                          </li>
                        )
                      )}

                      <li className={`page-item ${page === pageCount ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage((p) => Math.min(pageCount, p + 1))}>
                          »
                        </button>
                      </li>
                    </ul>
                  </nav>
                ) : null}
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>

      {/* =========================
          MODAL FORM (Criar/Editar)
         ========================= */}
      <Modal
        show={openForm}
        onHide={closeForm}
        centered
        backdrop="static"
        keyboard={!saving}
        className="pretty-modal"
      >
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="icon-wrap">
                <FiUsers style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 650 }}>
                  {editing ? "Atualizar comercial" : "Registar comercial"}
                </div>
                <div className="title-sub">Preenche os campos essenciais de forma organizada.</div>
              </div>
            </div>

            {photoPreview ? (
              <Avatar
                variant="rounded"
                src={photoPreview}
                alt="Preview"
                sx={{ width: 44, height: 44, borderRadius: 3 }}
              />
            ) : null}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error ? (
              <div className="alert alert-danger py-2 mb-3" style={{ borderRadius: 14 }}>
                {error}
              </div>
            ) : null}

            <Form>
              <div className="form-grid">
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-card-text" />
                    Identificação
                  </div>

                  <div className="form-grid">
                    <Form.Group>
                      <Form.Label>
                        Nome <span className="req">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={form.name}
                        onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                        placeholder="Ex.: João Manuel"
                        required
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Estado</Form.Label>
                      <Form.Select
                        value={form.status}
                        onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}
                      >
                        <option value="ativo">Ativo</option>
                        <option value="inativo">Inativo</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-telephone" />
                    Contacto
                  </div>

                  <Form.Group className="mb-2">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      value={form.email}
                      onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                      placeholder="ex.: comercial@email.com"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Telefone</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.phone}
                      onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))}
                      placeholder="+244 9xx xxx xxx"
                    />
                  </Form.Group>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-geo-alt" />
                    Localização
                  </div>

                  <Form.Group>
                    <Form.Label>Região</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.region}
                      onChange={(e) => setForm((p) => ({ ...p, region: e.target.value }))}
                      placeholder="Ex.: Luanda / Sul / Norte..."
                    />
                    <div className="helper">Região de atuação do comercial.</div>
                  </Form.Group>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-sticky" />
                    Notas
                  </div>

                  <Form.Group>
                    <Form.Label>Notas</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.notes}
                      onChange={(e) => setForm((p) => ({ ...p, notes: e.target.value }))}
                      placeholder="Observações rápidas..."
                    />
                  </Form.Group>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-image" />
                    Foto do comercial
                  </div>

                  <div className="upload-row">
                    <div className="preview-box">
                      {photoPreview ? (
                        <img
                          src={photoPreview}
                          alt="Preview"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div className="preview-note">Sem foto</div>
                      )}
                    </div>

                    <div style={{ flex: 1, minWidth: 220 }}>
                      <Form.Label style={{ marginTop: 2 }}>Escolher ficheiro</Form.Label>
                      <Form.Control type="file" onChange={handlePhotoChange} />
                      <div className="helper">Use uma imagem leve para melhor desempenho.</div>
                    </div>

                    {photoPreview ? (
                      <div style={{ marginLeft: "auto" }}>
                        <Avatar
                          variant="rounded"
                          src={photoPreview}
                          alt="Preview"
                          sx={{ width: 84, height: 84, borderRadius: 4 }}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button variant="outline-secondary" className="btn-soft" onClick={closeForm} disabled={saving}>
              Cancelar
            </Button>

            <Button variant="primary" onClick={saveCommercial} disabled={saving}>
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A guardar...
                </>
              ) : editing ? (
                "Atualizar"
              ) : (
                "Registar"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* =========================
          MODAL ASSIGN (Atribuir escolas)
         ========================= */}
      <Modal
        show={openAssign}
        onHide={closeAssign}
        centered
        backdrop="static"
        keyboard={!saving}
        className="pretty-modal"
      >
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="icon-wrap">
                <FiCheckSquare style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 650 }}>Atribuir escolas</div>
                <div className="title-sub">
                  Comercial: <b>{assignCommercial?.name || "—"}</b>
                </div>
              </div>
            </div>

            <span className="pill">
              <TbSchool />
              Selecionadas: {selectedInstituteCodes.length}
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            <div className="assign-wrap">
              <div className="assign-head">
                <div style={{ flex: 1, minWidth: 260 }}>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-white">
                      <FiSearch />
                    </span>
                    <input
                      className="form-control"
                      placeholder="Pesquisar escola (nome, código, província...)"
                      value={assignQ}
                      onChange={(e) => setAssignQ(e.target.value)}
                    />
                  </div>
                  <div className="helper">Clique para marcar/desmarcar escolas.</div>
                </div>

                <div className="d-flex gap-2 flex-wrap">
                  <button className="btn btn-outline-dark btn-sm rounded-pill" onClick={selectAllVisible} disabled={saving}>
                    Selecionar visíveis
                  </button>
                  <button className="btn btn-outline-secondary btn-sm rounded-pill" onClick={clearAll} disabled={saving}>
                    Limpar
                  </button>
                </div>
              </div>

              <div style={{ maxHeight: 420, overflow: "auto" }}>
                <table className="assign-table">
                  <thead>
                    <tr>
                      <th style={{ width: 48 }}>Sel.</th>
                      <th>Escola</th>
                      <th style={{ width: 160 }}>Província/Estado</th>
                    </tr>
                  </thead>

                  <tbody>
                    {assignFilteredInstitutes.map((inst) => {
                      const checked = selectedInstituteCodes.includes(inst.code);
                      const logoSrc = inst?.logo ? resolvePhotoSrc(inst.logo) : null;

                      return (
                        <tr key={inst.code} onClick={() => toggleInstitute(inst.code)} style={{ cursor: "pointer" }}>
                          <td onClick={(e) => e.stopPropagation()}>
                            <input
                              className="chk"
                              type="checkbox"
                              checked={checked}
                              onChange={() => toggleInstitute(inst.code)}
                            />
                          </td>

                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <Avatar
                                variant="rounded"
                                src={logoSrc || undefined}
                                alt={inst.name}
                                sx={{ width: 34, height: 34, borderRadius: 2 }}
                              />
                              <div>
                                <div style={{ fontWeight: 650 }}>{safeValue(inst.name, "—")}</div>
                                <span className="pill">
                                  <TbBuilding />
                                  {safeValue(inst.code)}
                                </span>
                              </div>
                            </div>
                          </td>

                          <td>
                            <span className="pill">
                              <TbMapPin />
                              {safeValue(inst.state)}
                            </span>
                          </td>
                        </tr>
                      );
                    })}

                    {assignFilteredInstitutes.length === 0 ? (
                      <tr>
                        <td colSpan={3}>
                          <span className="small-muted">Nenhuma escola encontrada.</span>
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button variant="outline-secondary" className="btn-soft" onClick={closeAssign} disabled={saving}>
              Cancelar
            </Button>

            <Button variant="primary" onClick={saveAssignments} disabled={saving}>
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A guardar...
                </>
              ) : (
                "Guardar atribuições"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* =========================
          MODAL DOCS (Anexos) - upload
         ========================= */}
      <Modal
        show={openDocs}
        onHide={closeDocs}
        centered
        backdrop="static"
        keyboard={!saving}
        className="pretty-modal"
      >
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="icon-wrap">
                <FiPaperclip style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 650 }}>Anexos do comercial</div>
                <div className="title-sub">
                  Comercial: <b>{docsCommercial?.name || "—"}</b>
                </div>
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error ? (
              <div className="alert alert-danger py-2 mb-3" style={{ borderRadius: 14 }}>
                {error}
              </div>
            ) : null}

            <Form>
              <div className="form-grid">
                <div className="cardlet">
                  <div className="cardlet-title">
                    <FiPaperclip />
                    Documento
                  </div>

                  <Form.Group className="mb-2">
                    <Form.Label>
                      Título <span className="req">*</span>
                    </Form.Label>
                    <Form.Control value={docTitle} onChange={(e) => setDocTitle(e.target.value)} placeholder="Ex.: BI / Contrato..." />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Nota</Form.Label>
                    <Form.Control value={docNote} onChange={(e) => setDocNote(e.target.value)} placeholder="Opcional..." />
                  </Form.Group>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">
                    <FiUpload />
                    Ficheiros
                  </div>

                  <Form.Group>
                    <Form.Label>Selecionar (múltiplos)</Form.Label>
                    <Form.Control
                      type="file"
                      multiple
                      onChange={(e) => setDocFiles(Array.from(e.target.files || []))}
                    />
                    <div className="helper">
                      {docFiles.length ? `${docFiles.length} ficheiro(s) selecionado(s).` : "Nenhum ficheiro selecionado."}
                    </div>
                  </Form.Group>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button variant="outline-secondary" className="btn-soft" onClick={closeDocs} disabled={saving}>
              Cancelar
            </Button>

            <Button variant="primary" onClick={uploadDocs} disabled={saving}>
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A enviar...
                </>
              ) : (
                "Enviar"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
